import { w2dImage, w2dPdf } from "../model/w2dclasses";
import { fetchWrapper } from "./fetchWrapper";
import config from "../config";

export default {
    buildRestUrl(url) {
        //var cl = window.location;
        //var result = cl.protocol + "//" + cl.hostname + ":3000" + url;
        //return result;
        var result = config.baseUrl + url;
        return result;
        //return url;
    },
    /**
     * getFile, reads the file data from the database
     * The function throws in case of error
     * @param {string} theFileId - The database id of the file to be retrieved, returns a file object
     */
    async getFile(theFileId) {
        let url = this.buildRestUrl("/file/" + theFileId);

        var response = await fetchWrapper(url, {
            method: "GET"
        });
        return response;
    },
    async addImgToProject(
        imgLink,
        imgname,
        theProjectId,
        theAreaName,
        options
    ) {
        const opt = options || {};
        let url = this.buildRestUrl("/imgtoproject");
        var imgData = new w2dImage(
            imgname,
            imgLink,
            theProjectId,
            theAreaName,
            opt.dest
        );
        if (opt.iptc && opt.iptc.caption) {
            imgData.body = opt.iptc.caption;
        }
        if (opt.mimetype) {
            imgData.mimetype = opt.mimetype;
        }
        var response = await fetchWrapper(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            data: {
                uploadToDesk: false,
                storeInProject: true,
                config: opt.config,
                imgData: imgData
            }
        });
        return response.data.projectJson;
    }, // addImgToProject

    // imglink, result, file.name
    async addPdfToProject(
        imgLink,
        doclink,
        body,
        imgname,
        theProjectId,
        theAreaName,
        options
    ) {
        const opt = options || {};
        let url = this.buildRestUrl("/pdftoproject");

        let pdfData = new w2dPdf(imgname, doclink, theProjectId, theAreaName);
        pdfData.imglink = imgLink;
        pdfData.body = body;
        if (opt.dest) {
            pdfData.dest = opt.dest;
        }

        var response = await fetchWrapper(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            data: pdfData
        });
        return response.data;
    } // addPdfToProject
};
